var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            direction: "rtl",
            size: "50%",
            "modal-append-to-body": false,
            "before-close": _vm.handleClose,
            title:
              _vm.openType == 1
                ? _vm.$t("billingPage.billingAdd")
                : _vm.openType == 2
                ? _vm.$t("billingPage.billingEdit")
                : _vm.$t("billingPage.billingView"),
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("ChannelManagement.new.title")) + " "),
          ]),
          _vm.drawer
            ? _c(
                "el-form",
                {
                  ref: "form",
                  staticStyle: { padding: "16px" },
                  attrs: {
                    "label-position": "top",
                    model: _vm.form,
                    disabled: _vm.openType == 3,
                    rules: _vm.rules,
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.categoryCode"),
                                prop: "code",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  disabled: _vm.openType != 1,
                                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                                  placeholder: _vm.$t("inputText"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.code,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "code", $$v)
                                  },
                                  expression: "form.code",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.categoryName"),
                                prop: "name",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                                  placeholder: _vm.$t("inputText"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "name", $$v)
                                  },
                                  expression: "form.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.quotationGroup"),
                                prop: "group",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: { "lov-code": "BILL_CATEGORY_GROUP" },
                                model: {
                                  value: _vm.form.group,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "group", $$v)
                                  },
                                  expression: "form.group",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.SAPGroup"),
                                prop: "sapGroup",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: { "lov-code": "BILL_SAP_GROUP" },
                                model: {
                                  value: _vm.form.sapGroup,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sapGroup", $$v)
                                  },
                                  expression: "form.sapGroup",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.department"),
                                prop: "department",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: {
                                  multiple: "",
                                  clearable: false,
                                  "option-list": _vm.departmentList,
                                },
                                model: {
                                  value: _vm.form.department,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "department", $$v)
                                  },
                                  expression: "form.department",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 * 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.tag"),
                                prop: "tag",
                              },
                            },
                            [
                              _vm._l(_vm.dataTagsList, function (tag, index) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: index,
                                    attrs: {
                                      closable: "",
                                      "disable-transitions": false,
                                      size: "medium",
                                    },
                                    on: {
                                      close: function ($event) {
                                        return _vm.onDEL(tag)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(tag) + " ")]
                                )
                              }),
                              _vm.inputVisible
                                ? _c("el-input", {
                                    ref: "saveTagInput",
                                    staticClass: "input-new-tag",
                                    attrs: { size: "medium" },
                                    on: { blur: _vm.handleInputConfirm },
                                    nativeOn: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.handleInputConfirm.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.tag,
                                      callback: function ($$v) {
                                        _vm.tag = $$v
                                      },
                                      expression: "tag",
                                    },
                                  })
                                : _c(
                                    "el-button",
                                    {
                                      staticClass: "button-new-tag",
                                      attrs: { size: "mini" },
                                      on: { click: _vm.showInput },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("billingPage.createTag"))
                                      ),
                                    ]
                                  ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.description"),
                                prop: "description",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  type: "textarea",
                                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                                  placeholder: _vm.$t("inputText"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "description", $$v)
                                  },
                                  expression: "form.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.Logic"),
                                prop: "logic",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  type: "textarea",
                                  rows: 5,
                                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                                  placeholder: _vm.$t("inputText"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.logic,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "logic", $$v)
                                  },
                                  expression: "form.logic",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "foot" },
            [
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.openType == 3 },
                  on: { click: _vm.onComfirm },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("dialogData", {
        ref: "dialogDataRef",
        attrs: { positionList: _vm.positionList, checkList: _vm.checkList },
        on: { submit: _vm.onSubmit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }